import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Header, Navigation } from '../components';



const Main = ({ children }) => {
  if (
    window.location.pathname.toLowerCase() !== '/login'
    && window.location.pathname.toLowerCase() !== '/cadastro'
    && window.location.pathname.toLowerCase() !== '/esqueci-senha'
  ) {
    return (
      <div className="app-wrapper">
        <Navigation />

        <div className="main-wrapper">
          <Header />
          <main>{children}</main>
          <ToastContainer
            closeButton={<i className="material-icons">close</i>}
            draggable={false}
            hideProgressBar
          />
        </div>
      </div>
    );
  }
  return (
    <div>
      <main className="login">{children}</main>
      <ToastContainer
        closeButton={<i className="material-icons">close</i>}
        draggable={false}
        hideProgressBar
      />
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/app/Main.js